module.exports = __webpack_public_path__ + "img/C0.55c1f9ff.png";